import { Typography } from "@mui/material";
import { GridOverlay } from "@mui/x-data-grid";

const XNoRowsOverlay = ({ text = "No Rows" }: { text: string }) => {
  return (
    <GridOverlay>
      <Typography>{text}</Typography>
    </GridOverlay>
  );
};

export default XNoRowsOverlay;
